let activeConfirm = null;

export function harwinConfirm(message, options = {}) {
  if (activeConfirm) activeConfirm(false);

  return new Promise((resolve) => {
    activeConfirm = resolve;
    const overlay = document.createElement("div");
    overlay.className = "harwin-confirm-overlay";

    const title = options.title || (/delete|remove|clear|cancel/i.test(String(message)) ? "Please Confirm" : "Confirmation");
    const confirmText = options.confirmText || (/delete|remove|clear/i.test(String(message)) ? "Delete" : "Confirm");
    const tone = /delete|remove|clear|cancel/i.test(String(message)) ? "danger" : "primary";

    overlay.innerHTML = `
      <div class="harwin-confirm-card" role="dialog" aria-modal="true" aria-labelledby="harwin-confirm-title">
        <div class="harwin-confirm-icon ${tone}">${tone === "danger" ? "!" : "✓"}</div>
        <div class="harwin-confirm-content">
          <h3 id="harwin-confirm-title">${escapeHtml(title)}</h3>
          <p>${escapeHtml(String(message || "Are you sure?")).replace(/\n/g, "<br>")}</p>
        </div>
        <div class="harwin-confirm-actions">
          <button type="button" class="harwin-confirm-cancel">Cancel</button>
          <button type="button" class="harwin-confirm-ok ${tone}">${escapeHtml(confirmText)}</button>
        </div>
      </div>`;

    const finish = (value) => {
      if (!overlay.isConnected) return;
      overlay.remove();
      activeConfirm = null;
      document.removeEventListener("keydown", onKey);
      resolve(value);
    };
    const onKey = (event) => {
      if (event.key === "Escape") finish(false);
      if (event.key === "Enter") finish(true);
    };
    overlay.querySelector(".harwin-confirm-cancel").onclick = () => finish(false);
    overlay.querySelector(".harwin-confirm-ok").onclick = () => finish(true);
    overlay.onclick = (event) => { if (event.target === overlay) finish(false); };
    document.addEventListener("keydown", onKey);
    document.body.appendChild(overlay);
    setTimeout(() => overlay.querySelector(".harwin-confirm-ok")?.focus(), 0);
  });
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
